"use strict";

exports.__esModule = true;
exports.findBounds = findBounds;
exports.mapButtons = mapButtons;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function findBounds(index, menuSize, totalPages) {
  var leftSide = Math.floor((menuSize - 1) / 2);
  var rightSide = Math.ceil((menuSize - 1) / 2);

  if (index - leftSide < 1) {
    var end = totalPages > menuSize ? menuSize : totalPages;
    return [1, end];
  }

  if (index + rightSide > totalPages) {
    var start = totalPages - menuSize + 1 > 0 ? totalPages - menuSize + 1 : 1;
    return [start, totalPages];
  }

  return [index - leftSide, index + rightSide];
}

function mapButtons(Component, index, menuSize, _onClick, otherProps, passAttributeToMenuItem, totalPages) {
  var _findBounds = findBounds(index, menuSize, totalPages),
      start = _findBounds[0],
      end = _findBounds[1];

  var numberButtons = [];

  var _loop = function _loop(i) {
    var isActive = index === i;
    numberButtons.push( /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
      componentEl: Component,
      disabled: isActive,
      key: i,
      margin: {
        left: 'xs',
        right: 'xs'
      },
      onClick: function onClick(e) {
        return _onClick(e, i);
      },
      tertiary: true,
      type: "button"
    }, otherProps, passAttributeToMenuItem(i)), i));
  };

  for (var i = start; i <= end; i += 1) {
    _loop(i);
  }

  return numberButtons;
}